import { useQuery } from "@tanstack/react-query";
import * as adminApi from "@/services/adminApi";

export const adminKeys = {
  all: ["admin"] as const,
  cronSchedule: () => [...adminKeys.all, "cron-schedule"] as const,
};

export function useAdminCronSchedule() {
  return useQuery({
    queryKey: adminKeys.cronSchedule(),
    queryFn: adminApi.getCronScheduleStatus,
    staleTime: 60_000,
  });
}
